export const RECEIVED_VOTES = "RECEIVED_VOTES";
export const CREATED_VOTE = "CREATED_VOTE";
export const UPDATED_VOTE = "UPDATED_VOTE";
export const DELETED_VOTE = "DELETED_VOTE";
export const CLEARED_VOTES_USER_DATA = "CLEARED_VOTES_DIRECTIONS";
